/**
 * MapEntity Class file
 *
 * Generated file, don't touch manually
 *
 * ModelVersion: 90004
 */
import { BaseEntity } from "@archipad-js/core/orm";
import { ProjectEntity } from "../ProjectEntity";
import { RegionEntity } from "../RegionEntity";
import { MapVersionEntity } from "../MapVersionEntity";
import { MapLocationEntity } from "../MapLocationEntity";
import { MapSceneEntity } from "../MapSceneEntity";
import { BugEntity } from "../BugEntity";
import { MapEntity } from "../MapEntity";
declare global {
    interface EntityTypeMap {
        Map: MapEntity;
    }
}
export abstract class MapGeneratedEntity extends BaseEntity {
    public abstract mapId: string;
    public abstract templateId: string | null;
    public abstract filename: string;
    public abstract type: number;
    public abstract fileType: number;
    public abstract orientation: number;
    public abstract typeOrderHint: number | null;
    public abstract project: ProjectEntity;
    public abstract region: RegionEntity | null;
    public abstract readonly versions: ReadonlyArray<MapVersionEntity>;
    public abstract activeVersion: MapVersionEntity | null;
    public abstract readonly locations: ReadonlyArray<MapLocationEntity>;
    public abstract readonly scenes: ReadonlyArray<MapSceneEntity>;
    public abstract readonly bugs: ReadonlyArray<BugEntity>;
}
